import axios from 'src/utils/axios';

export const GET_LLM_CONFIG = 'GET_LLM_CONFIG';
export const ADD_LLM_CONFIG = 'ADD_LLM_CONFIG';
export const UPDATE_LLM_CONFIG = 'UPDATE_LLM_CONFIG';
export const DELETE_LLM_CONFIG = 'DELETE_LLM_CONFIG';
export const CLEAR_LLM_CONFIG = 'CLEAR_LLM_CONFIG';
export const GET_LLM_CONFIG_VERSIONS = 'GET_LLM_CONFIG_VERSIONS';

export const getLLMConfig = (botId) => async (dispatch) => {
  try {
    const response = await axios.get(`/api/llm-completion-config/${botId}`);
    dispatch({
      type: GET_LLM_CONFIG,
      payload: { ...response.data, botId }
    });
    return response.data;
  } catch (error) {
    console.error('Error getting LLM config:', error);
  }
};

export const addLLMConfig = (config, versionMeta) => async (dispatch) => {
  try {
    const response = await axios.post('/api/llm-completion-config', {
      config,
      versionMeta
    });
    dispatch({
      type: ADD_LLM_CONFIG,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    console.error('Error adding LLM config:', error);
    throw error;
  }
};

export const updateLLMConfig = (config, versionMeta) => async (dispatch) => {
  try {
    const response = await axios.put('/api/llm-completion-config', {
      config,
      versionMeta
    });
    dispatch({
      type: UPDATE_LLM_CONFIG,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    console.error('Error updating LLM config:', error);
    throw error;
  }
};

export const deleteLLMConfig = (id) => async (dispatch) => {
  try {
    await axios.delete(`/api/llm-completion-config/${id}`);
    dispatch({
      type: DELETE_LLM_CONFIG,
      payload: { id }
    });
    return { id };
  } catch (error) {
    console.error('Error deleting LLM config:', error);
    throw error;
  }
};

export const clearLLMConfig = (botId) => ({
  type: CLEAR_LLM_CONFIG,
  payload: { botId }
});

export const getLLMConfigVersions = (botId, params = {}) => async (dispatch) => {
  try {
    const response = await axios.get(
      `/api/llm-completion-config/${botId}/versions`,
      { params }
    );
    dispatch({
      type: GET_LLM_CONFIG_VERSIONS,
      payload: { botId, versions: response.data.versions || [] }
    });
    return response.data;
  } catch (error) {
    console.error('Error getting LLM config versions:', error);
  }
};

export const restoreLLMConfigVersion = (versionId, options = {}) => async (dispatch) => {
  try {
    const response = await axios.post(
      `/api/llm-completion-config/restore/${versionId}`,
      options
    );
    if (response.data?.config?.bot_id) {
      dispatch({
        type: UPDATE_LLM_CONFIG,
        payload: response.data
      });
    }
    return response.data;
  } catch (error) {
    console.error('Error restoring LLM config version:', error);
    throw error;
  }
};
